export default {
  'sendpasswordsuccessfully.sendpassword': 'パスワードが送信されました',
  'sendpasswordsuccessfully.and': 'と',
  'sendpasswordsuccessfully.successfully': '完了しました',
  'sendpasswordsuccessfully.passwordsentto': 'パスワード回復リンクを電子メールに送信 ',
  'sendpasswordsuccessfully.checkemail':
    'パスワードのリセットのためにメールをチェックしてください、',
};
